interface FilterItem {
    key: string;
    value: string;
}

export interface Filter {
    name: string;
    label: string;
    list: FilterItem[];
}

export const recipeFilters = [
        {
        name: "field_category",
        label: "Categoría",
        list: []//this field is dinamically populated in recipe index
    },
    {
        label: "Dificultad",
        name: "field_difficulty",
        list: [
            {
                key: "Fácil",
                value: "Fácil"
            },
            {
                key: "Media",
                value: "Media"
            },
            {
                key: "Difícil",
                value: "Difícil"
            }
        ]
    },
    {
        name: "field_cooking_time",
        label: "Tiempo",
        list: [
            {
                key: "0 - 15",
                value: [0, 15]
            },
            {
                key: "16 - 44",
                value: [16, 44]
            },
            {
                key: "45 -59",
                value: [45, 59]
            },
            {
                key: "60 +",
                value: [60, 999]
            }
        ]
    },
    {
        name: "field_servings",
        label: "Raciones",
        list: [
            {
                key: "1",
                value: [0, 1]
            },
            {
                key: "2",
                value: [2, 2]
            },
            {
                key: "3",
                value: [3, 3]
            },
            {
                key: "4",
                value: [4, 4]
            },
            {
                key: "5 o más",
                value: [5, 99]
            }
        ]
    },
] as Filter[];